import { i18n } from '@/plugins/i18n'
import moment from 'moment'
import vuetify from '@/plugins/vuetify'

const KEY = 'siteLang'

const momentLocaleMap = {
  en: 'en',
  pt: 'pt', // or 'pt-br' if you're targeting Brazilian Portuguese
}

export function setSiteLocale(code, { rtl = false, skipI18n = false } = {}) {
  const gl = i18n.global
  if (!skipI18n) {
    if (
      gl &&
      gl.locale &&
      typeof gl.locale === 'object' &&
      'value' in gl.locale
    ) {
      gl.locale.value = code
    } else {
      gl.locale = code
    }
  }

  // Sync moment
  moment.locale(momentLocaleMap[code] || code)

  // Sync Vuetify's built-in text; languages it has no pack for stay English
  const vuetifyLocale = vuetify.locale
  if (vuetifyLocale) {
    vuetifyLocale.current.value = vuetifyLocale.messages.value[code] ? code : 'en'
  }

  // dir + document language (also helps avoid mismatched auto-translate prompts)
  document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr')
  document.documentElement.setAttribute(
    'lang',
    code && String(code).length ? String(code) : 'en'
  )

  try {
    localStorage.setItem(KEY, code)
  } catch {
    /* empty */
  }
}

export function getSavedSiteLocale() {
  try {
    return localStorage.getItem(KEY) || null
  } catch {
    return null
  }
}

export function getDateFormatConfig() {
  const gl = i18n.global
  const { t } = gl

  return {
    dayOfWeekNames: t('dates.days.full'),
    dayOfWeekNamesShort: t('dates.days.short'),
    monthNames: t('dates.months.full'),
    monthNamesShort: t('dates.months.short'),
    // Use the key that exists in both en.json and pt.json
    format: t('dates.prettyFormat'),
    timezone: 0,
  }
}
